import { getUser } from 'shj-utils'
import { get } from 'lodash-es'
import {updateLastCallTime, viewPhoneBySource} from '@/services/callCenter'
import { SMessage } from 'shj-components'
import { SOFT_PHONE_EVENTS, triggerEvent, triggerPhoneCall } from '@shj/use-soft-phone'
import SIPCall from '@/utils/sip/sip_call.ts'
import { zhiTongReturnCall } from '@/services/crmTool.ts'

export function onCallUp(props) {
  const { setCallData, detailInfo = {}, callData, callState } = props
  if (callData.callLine === 'HELI') {
    fetchCall({ setCallData, detailInfo })
  } else {
    fetchSipCall({ setCallData, detailInfo, callData, callState })
  }
}

export function fetchCall(props) {
  const userInfo = getUser()
  const { setCallData, newPhone, detailInfo } = props
  if (newPhone && detailInfo.phone !== newPhone) {
    if (!/^1\d{10}$/.test(newPhone))
      return SMessage.confirm({
        title: '请输入正确的电话号码',
        content: null,
      })
    return triggerEvent(SOFT_PHONE_EVENTS.SOFT_PHONE_DIALOUT, {
      phone: newPhone,
      interfaceData: {
        agentName: userInfo.userName,
        tenantId: userInfo.ucenterUserId,
        agentType: 'SEAT',
      },
    })
  } else {
    const interfaceData = {
      bizId: detailInfo.id,
      id: detailInfo.id,
      clueName: detailInfo.name,
      agentName: get(userInfo, 'userName'),
      tenantId: get(userInfo, 'userIdentityId'),
      agentType: 'SEAT',
    }
    const channel = detailInfo.channel || detailInfo.channelName || detailInfo.channelClue?.channelName
    const panelShowData = { ...interfaceData, channel }
    setCallData(callData => ({ ...callData, loading: true, disabled: true }))
    viewPhoneBySource(detailInfo['id'], 'salesWorkBenchClueViewPhone')
      .then((res: any) => {
        triggerPhoneCall({
          phone: res,
          interfaceData,
          panelShowData,
          detailData: detailInfo,
          disloutSuccess: () => {
            updateLastCallTime(detailInfo.id)
            setCallData(callData => ({ ...callData, loading: false, disabled: true }))
          },
          disloutAbort: () => {
            setCallData(callData => ({ ...callData, loading: false, disabled: false }))
          },
        })
      })
      .catch(() => setCallData(callData => ({ ...callData, loading: false, disabled: false })))
  }
}

export function fetchSipCall(props) {
  const { setCallData, newPhone, detailInfo, callState } = props
  if (newPhone && detailInfo.phone !== newPhone) {
    if (!/^1\d{10}$/.test(newPhone))
      return SMessage.confirm({
        title: '请输入正确的电话号码',
        content: null,
      })
    onSipCallUp(newPhone, setCallData)
  } else {
    console.log(callState, 'callState')
    if (callState.zitongCallReturn ?? false) {
      zhiTongReturnCall(detailInfo.id || null).then(res => {
        const code = `${res.code}`
        if (code === '200' || code === '0') {
          SMessage.confirm({
            title: '呼叫成功',
            content: '请稍后接听电话',
          })
        } else {
          SMessage.confirm({
            title: '呼叫失败',
            content: res.text || '请稍后重试',
          })
        }
      })
    } else {
      setCallData(callData => ({ ...callData, loading: true, disabled: true }))
      viewPhoneBySource(detailInfo['id'], 'salesWorkBenchClueViewPhone')
        .then((res: any) => {
          onSipCallUp(res, setCallData, detailInfo['id'])
        })
        .catch(() => setCallData(callData => ({ ...callData, loading: false, disabled: false })))
    }
  }
}

export const onSipCallUp = (phone, setCallData, clueId?) => {
  SIPCall.call(phone, {
    clueId: clueId,
    accepted: () => {
      setCallData(callData => ({ ...callData, loading: false, disabled: true }))
    },
    ended: () => {
      setCallData(callData => ({ ...callData, loading: false, disabled: false }))
    },
    failed: () => {
      setCallData(callData => ({ ...callData, loading: false, disabled: false }))
    },
  }).catch(err => {
    const message = err?.message || ''
    if (typeof message == 'string' && message.includes('device')) {
      SMessage.confirm({
        title: '呼叫失败',
        content: '未识别到扬声器或麦克风',
        onOk: () => {
          setCallData(callData => ({ ...callData, loading: false, disabled: false }))
        },
        onCancel: () => {
          setCallData(callData => ({ ...callData, loading: false, disabled: false }))
        },
      })
    }
  })
}
